/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', function () {
	const accordionHeaders = document.querySelectorAll('.person-card');

	accordionHeaders.forEach(exapndable=> {
        const header = exapndable.querySelector('.expandable-trigger');
		header?.addEventListener('click', function () {
            accordionHeaders.forEach(element => {
                if (element != exapndable) {

                    const content = element.querySelector('.expandable-content-person');
                    //content.style.display = 'none';
                    element.classList.add('content-hidden');

                }

            });
			const content = this.nextElementSibling;

			content.style.display = content.style.display === 'block' ? 'none' : 'block';
            exapndable.classList.toggle('content-hidden');
			header.innerText = content.style.display === 'block' ? 'Manj ...' : 'Več ...';

		});
	});
});
